module.exports = __webpack_public_path__ + "static/media/stew.6208b9ae.svg";